import { TeamBlock, getTeams } from "components/team";
import teamContent from "../../../../content/data/team.json";
import * as React from 'react';
export default {
  TeamBlock,
  getTeams,
  teamContent,
  React
};